import { Flex } from '@chakra-ui/react';
import { DetailsBarProps, SsiDetailBar } from './ssi-detail-bar';

export interface SubScore {
  professionalBrand: number;
  findRightPeople: number;
  insightEngagement: number;
  strongRelationship: number;
}

export interface SsiDetailsProps {
  scores: SubScore;
  delta: SubScore;
}

export const SsiDetails = ({ scores, delta }: SsiDetailsProps) => {
  return (
    <Flex direction="column" justifyContent={'space-between'} h="100%" gap={4}>
      {['professionalBrand', 'findRightPeople', 'insightEngagement', 'strongRelationship'].map((pillar) => (
        <SsiDetailBar key={pillar} pillar={pillar} score={scores[pillar]} delta={delta[pillar]} />
      ))}
    </Flex>
  );
};
